import { BASE_URL, post } from "./Common";

/**
 * The one-off jobs that move legacy profile pictures into the per-user layout (RSD-1637).
 * The API runs each in the background and logs its summary, so starting one is all the
 * portal can do.
 */
export type ProfilePhotoJob = "backfill" | "cleanup";

export type ProfilePhotoJobStart = "STARTED" | "ALREADY_RUNNING" | "FAILED";

export const startProfilePhotoJob = async (
  job: ProfilePhotoJob,
  authToken: string,
): Promise<ProfilePhotoJobStart> => {
  const url = `${BASE_URL}/profile-photos/${job}`;

  try {
    const response = await post(url, authToken);

    if (response.status === 202) {
      return "STARTED";
    }

    return response.status === 409 ? "ALREADY_RUNNING" : "FAILED";
  } catch (Error) {
    return "FAILED";
  }
};
